import { bool, node } from "prop-types";
import cx from "classnames";

const propTypes = {
  children: node,
  disabled: bool,
  checked: bool,
};

// NOTE using defaultChecked because this is uncontrolled
const CircleCheck = (props) => {
  const { children, disabled, checked, ...otherProps } = props;

  return (
    <label className="circle-check" {...otherProps}>
      <input type="checkbox" disabled={disabled} defaultChecked={checked} />
      <span
        className={cx("circle-check__custom", {
          "circle-check__custom--checked": checked,
        })}
      ></span>
      {children}
    </label>
  );
};

CircleCheck.propTypes = propTypes;
export default CircleCheck;
